module.exports = __webpack_public_path__ + "static/media/logo_iphone.cf11ebcc.png";